import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewbox="0 0 48 48" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M25.256 4.005c.947 9.152 3.485 19.364 7.612 30.637C30.134 38.488 27.193 41.807 24 45c-3.1-3.1-5.961-6.317-8.627-10.021 4.134-11.421 6.624-21.746 7.468-30.975a165.88 165.88 0 0 1 2.415 0Zm3.803.075c1.195.038 2.325.09 3.39.15 1.459 3.716 4.35 8.865 8.674 15.445-1.774 4.156-3.64 7.756-5.615 10.974-3.927-10.887-6.077-19.744-6.45-26.57Zm-10.075-.002c-.202 6.824-2.29 15.804-6.265 26.939-2.06-3.312-4-7.027-5.842-11.342 4.324-6.58 7.215-11.729 8.675-15.445 1.077-.061 2.22-.113 3.432-.152Zm18.278.525C43.172 5.193 46 6 46 6a143.01 143.01 0 0 1-2.932 8.79c-2.17-2.927-4.105-6.322-5.806-10.187Zm-26.524 0C9.037 8.468 7.1 11.863 4.932 14.79A143.704 143.704 0 0 1 2 6s2.827-.808 8.738-1.397Z" clip-rule="evenodd"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
